import { Layout, Row } from 'antd';
import { Outlet } from 'react-router-dom';

interface PageContentLayoutProps {
  fullwidth?: boolean;
}

const PageContentLayout = ({ fullwidth = false }: PageContentLayoutProps) => {
  const { Content } = Layout;

  if (fullwidth) {
    return <Outlet />;
  }

  return (
    <Layout className="!bg-white">
      <Content className="mx-2 sm:mx-16">
        <Row>
          <Outlet />
        </Row>
      </Content>
    </Layout>
  );
};

export default PageContentLayout;
